import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import useTranslate from '../../../../hooks/useTranslate';

declare var tidioChatApi: any;

const linkDecorations = {
  textDecorationLine: 'underline',
  cursor: 'pointer',
  lineHeight: '2',
  width: 'fit-content',
  color: '#050505',
};

const NeedSupportLinks = (props: { url?: string }) => {
  const t = useTranslate();
  const { url } = props;
  const display = url ? 'initial' : 'none';
  return (
    <Box
      sx={{
        padding: '10px 0',
      }}
    >
      <Typography variant="subtitle1">{t('needSupport?')}</Typography>
      <Typography
        variant="subtitle2"
        sx={{ ...linkDecorations, marginTop: '0.5em' }}
        onClick={() => {
          tidioChatApi.open();
        }}
        tabIndex={0}
      >
        {t('contactCustomerSupport')}
      </Typography>
      <Link href={url} target="_blank" rel="noopener noreferrer" display={display} tabIndex={0}>
        <Typography variant="subtitle2" sx={linkDecorations}>
          {t('mjm-userGuide')}
        </Typography>
      </Link>
    </Box>
  );
};

export default NeedSupportLinks;
